import styled from "styled-components";
import { MenuItem } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const FilterContainer = styled(MenuItem)`
    padding: 0 16px;
    min-height: 40px;
`;

export const MobileFilterHeader = styled.div`
    justify-content: space-between;
    align-items: center;
    display: flex;
    padding: 16px 16px 10px;
`;

export const FilterCountNumber = styled.span`
    display: flex;
    align-items: center;
    margin: auto;
    font-size: var(--size-10);
    font-weight: bold;
    line-height: 16px;
    color: var(--color-primary);
    text-align: center;
`;

export const CurrentFilterContainer = styled.div`
    padding: 12px 16px;
    max-width: 250px;
    @media ${breakpoints.xs} {
        max-width: inherit;
    }
`;

export const CleanFilter = styled(MenuItem)`
    justify-content: center;
    min-height: 40px;
    font-size: var(--size-12);
    font-weight: bold;
    line-height: 18px;
    color: var(--color-secondary);
    text-transform: uppercase;
`;

export const FilterCount = styled.div`
    display: flex;
    width: 20px;
    height: 14px;
    background-color: var(--color-tertiary);
    border-radius: var(--radius-10);
    flex-grow: 0;
    align-items: center;
    margin: 0 8px;
    order: 1;
`;

export const FilterCheck = styled.div<{ $selected: boolean }>`
    display: flex;
    align-items: center;
    order: 2;
    flex-grow: 1;
    justify-content: right;
    visibility: hidden;
    ${(props) =>
        props.$selected &&
        `
            visibility: visible;
  `}
`;

export const FilterTitle = styled.div<{ $selected: boolean }>`
    font-size: var(--size-12);
    line-height: 18px;
    text-transform: uppercase;
    flex-grow: 0;
    order: 1;
    margin-right: 8px;
    display: flex;
    align-items: center;
    color: var(--color-grey-800);
    ${(props) =>
        props.$selected &&
        `
            color: var(--color-secondary);
  `}
`;

export const StyledFilterDropdown = styled.div`
    .container {
        display: flex;
        align-items: flex-start;
        @media ${breakpoints.xs} {
            flex-direction: column;
        }

        .rowContainer {
            display: flex;

            .dropdownContainer {
                display: flex;
                flex-direction: column;
                width: auto;
                text-align: center;
                @media ${breakpoints.xs} {
                    width: 100%;
                }

                .filterButton {
                    width: 40px;
                    min-width: 40px !important;
                    height: 40px;
                    font-size: var(--size-16);
                    font-weight: bold;
                    color: var(--color-primary);
                    text-transform: none;
                    background: var(--color-white);
                    border: 1px solid var(--color-grey-600);
                    border-radius: var(--radius-10);

                    padding: initial;
                    box-shadow: none;

                    svg path {
                        fill: var(--color-secondary);
                    }

                    &:hover {
                        box-shadow: none;
                    }

                    @media ${breakpoints.xs} {
                        width: 100%;
                    }

                    .selectionNumber {
                        margin-left: 5px;
                        color: var(--color-secondary);
                    }
                }

                .filterDropdownLabel {
                    margin-top: 8px;
                    font-size: var(--size-8);
                    color: #939393;
                }

                .filterButton.active {
                    background: var(--color-secondary-light);
                }
            }
        }

        .selectionContainer {
            display: flex;
            flex-wrap: wrap;
            margin-left: 12px;
            @media ${breakpoints.sm} {
                overflow: -moz-scrollbars-none;
                overflow-x: auto;
                white-space: nowrap;
                -ms-overflow-style: none;
                &::-webkit-scrollbar {
                    height: 0;
                }
            }
            @media ${breakpoints.xs} {
                margin-top: 16px;
                &::-webkit-scrollbar {
                    height: 0;
                }
            }

            .selectedFilterOption {
                min-width: auto;
                padding: 8px 12px 8px 8px;
                margin-right: 4px;
                margin-left: 4px;
                font-size: var(--size-16);
                font-weight: normal;
                line-height: 24px;
                color: var(--color-grey-900);
                text-transform: none;
                white-space: nowrap;
                background: var(--color-secondary-light);
                border-radius: var(--radius-10);

                :hover {
                    background: var(--color-secondary-light);
                }

                @media ${breakpoints.xs} {
                    margin-top: 16px;
                    margin-right: 16px;
                    margin-left: 0;
                }
            }
        }

        .showHideContainer {
            display: flex;
            align-items: center;
            margin-left: 16px;

            > .toggler {
                font-size: var(--size-14);
                font-style: normal;
                font-weight: bold;
                line-height: 21px;
                color: var(--color-primary);
                text-decoration-line: underline;
                cursor: pointer;
            }
        }
    }
`;
